module.exports = __webpack_public_path__ + "img/landingDaftar.8fea8618.png";